module.exports = __webpack_public_path__ + "img/login1.1216cd86.png";